import {useEffect, useState} from 'react'

function useDebounce<T>(value: T, options: { delay?: number, callbackOnTime?: () => void }): T {
    const [debouncedValue, setDebouncedValue] = useState<T>(value)

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedValue(value)
            if (options.callbackOnTime) {
                options.callbackOnTime();
            }
        }, options.delay || 500)

        return () => {
            clearTimeout(timer)
        }
    }, [value, options.delay])

    return debouncedValue
}

export default useDebounce